import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Home, FileText, TrendingUp, PieChart, Menu } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../store/Store';
import { setSideBarToggle } from '../store/reducers/Layout/LayoutReducer';

export default function MobileBottomNavbar() {
   const { t } = useTranslation();
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const location = useLocation();
   const { sideBarToggle } = useSelector((state: RootState) => state.layout);

   const panelPath = `${process.env.PUBLIC_URL}/dashboard/panel`;
   const loanPath = `${process.env.PUBLIC_URL}/dashboard/loanRequest`;
   const investPath = `${process.env.PUBLIC_URL}/dashboard/investment`;
   const budgetPath = `${process.env.PUBLIC_URL}/dashboard/budget`;

   /** Check if current route matches any of the quick-access tabs */
   const quickAccessPaths = [panelPath, loanPath, investPath, budgetPath];
   const isOnQuickAccess = quickAccessPaths.some(
      (path) => location.pathname === path || location.pathname.startsWith(path + '/')
   );

   /** Close sidebar (if open) and navigate */
   const handleNavClick = (path: string) => (e: React.MouseEvent) => {
      e.preventDefault();
      if (!sideBarToggle) {
         dispatch(setSideBarToggle(true));
      }
      navigate(path);
   };

   const handleToggleMenu = (e: React.MouseEvent) => {
      e.preventDefault();
      dispatch(setSideBarToggle(!sideBarToggle));
   };

   return (
      <div className="mobile-bottom-navbar d-lg-none">
         <NavLink
            to={panelPath}
            onClick={handleNavClick(panelPath)}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
         >
            <Home className="nav-icon" size={22} strokeWidth={1.6} />
            <span className="nav-label">{t('Banco')}</span>
         </NavLink>

         <NavLink
            to={loanPath}
            onClick={handleNavClick(loanPath)}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
         >
            <FileText className="nav-icon" size={22} strokeWidth={1.6} />
            <span className="nav-label">{t('Préstamos')}</span>
         </NavLink>

         <NavLink
            to={investPath}
            onClick={handleNavClick(investPath)}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
         >
            <TrendingUp className="nav-icon" size={22} strokeWidth={1.6} />
            <span className="nav-label">{t('Inversion')}</span>
         </NavLink>

         <NavLink
            to={budgetPath}
            onClick={handleNavClick(budgetPath)}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
         >
            <PieChart className="nav-icon" size={22} strokeWidth={1.6} />
            <span className="nav-label">{t('Presupuesto')}</span>
         </NavLink>

         <a
            href="#menu"
            onClick={handleToggleMenu}
            className={`nav-item ${!isOnQuickAccess || !sideBarToggle ? 'active' : ''}`}
         >
            <Menu className="nav-icon" size={22} strokeWidth={1.6} />
            <span className="nav-label">{t('Menú')}</span>
         </a>
      </div>
   );
}
